function initSubMenuToggle() {
  const subMenuToggle = document.querySelectorAll( '.sub-menu-toggle' );

  if (subMenuToggle.length) {
    [...subMenuToggle].forEach( (element) => {
      element.addEventListener( 'click', (event) => {
        event.preventDefault();

        // Gives us so many css options :D
        element.nextElementSibling.classList.toggle( 'open' );
        element.parentNode.classList.toggle( 'open' );
        element.classList.toggle( 'open' );
      } );
    } );
  }
}

export default {
  init() {
    initSubMenuToggle();
  },
};